/** compareArray not in use. Can be removed. */
import {
	PERSONA,
	BASIC,
	CATMAN_TAG,
	MERCHANT_TAG,
	STANDARD_TAG,
	EXTERNAL,
	INTERNAL,
	NOW,
	LATER,
	TODAY,
	ONCE,
	ALL
} from 'constants/constant';
import { Helper } from '@walmart-dataventures/integrated-components';
import 'moment-timezone';

export const compareArray = (a1, a2) => {
	return (
		a1.length === a2.length &&
		a1.every(function (value, index) {
			return value === a2[index];
		})
	);
};

const { applicationOrigin } = Helper.getCurrentApplicationHostInfo();
export const getAPIURL = () => {
	return applicationOrigin;
};

export const deepClone = (obj) => {
	if (obj === null) return null;
	let clone = Object.assign({}, obj);
	Object.keys(clone).forEach(
		(key) => (clone[key] = typeof obj[key] === 'object' ? deepClone(obj[key]) : obj[key])
	);
	if (Array.isArray(obj)) {
		clone.length = obj.length;
		return Array.from(clone);
	}
	return clone;
};

export const contains = (arr, obj) => {
	let i = arr.length;
	while (i--) {
		if (JSON.stringify(arr[i]) === JSON.stringify(obj)) {
			return true;
		}
	}
	return false;
};

export const compareObj = (obj1, obj2) => {
	let n = 0;
	if (obj1.length !== obj2.length) {
		return false;
	}
	for (let i = 0; i < obj1.length; i++) {
		if (contains(obj2, obj1[i])) {
			n++;
		}
	}
	return n === obj1.length;
};

export const isObjEmpty = (obj) => {
	return Object.keys(obj).length === 0;
};

export const debounce = (fn, delay) => {
	let timeoutId;
	return function (...args) {
		if (timeoutId) {
			clearTimeout(timeoutId);
		}
		timeoutId = setTimeout(() => {
			fn(...args);
		}, delay);
	};
};

export const getPersona = (val, custType = BASIC) => {
	const { MERCHANT, BASIC_CATMAN, BASIC_VENDOR, SUPPLIER, CATMAN } = PERSONA;
	if (val === MERCHANT) return MERCHANT;

	if ([CATMAN_TAG, CATMAN].includes(val)) {
		if (custType === BASIC) {
			return BASIC_CATMAN;
		}
		return CATMAN;
	}

	if (custType === BASIC) {
		return BASIC_VENDOR;
	}

	return SUPPLIER;
};

export const getFullPersona = (val) => {
	const { MERCHANT, BASIC_CATMAN, CATMAN } = PERSONA;
	if (val === MERCHANT) return MERCHANT_TAG;
	const result = [CATMAN, BASIC_CATMAN].includes(val) ? CATMAN_TAG : STANDARD_TAG;
	return result;
};

export const checkPersona = (userType, catManUser) => {
	return (userType === EXTERNAL && !catManUser) || userType === INTERNAL;
};

/** this function to covert single digit into two
 * For ex: 1 become 01, 2 => 02
 */
export const format2Digit = Intl.NumberFormat('en-US', {
	minimumIntegerDigits: 2
});

export const _isEqual = (object1, object2) => {
	const keys1 = Object.keys(object1);
	const keys2 = Object.keys(object2);
	if (keys1.length !== keys2.length) {
		return false;
	}
	for (const key of keys1) {
		const val1 = object1[key];
		const val2 = object2[key];
		const areObjects = isObject(val1) && isObject(val2);
		if ((areObjects && !_isEqual(val1, val2)) || (!areObjects && val1 !== val2)) {
			return false;
		}
	}
	return true;
};
function isObject(object) {
	return object != null && typeof object === 'object';
}

export const convertRefreshTime = (refTm) => {
	const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

	const refDay = refTm.tz(timezone).format('ddd');
	const refDt = refTm.tz(timezone).format('MMM DD');
	const refTime = refTm.tz(timezone).format('HH:mm A');
	const tz = refTm.tz(timezone).format('z');

	return { day: refDay, date: refDt, time: refTime, timezone: tz };
};

/**
 * Format string,
 * converts 'PG Item' => 'pg_item'
 */
export const concatenateWords = (str) => {
	if (!str || str.length === 0) {
		return '';
	}
	return str.trim().toLowerCase().split(' ').join('_');
};

// Get the values for Dashboard's filter dropdowns
export const getListFilterValues = (reportLists) => {
	const Status = [ALL];
	const Dataset = [];
	const Frequency = [ALL];
	reportLists.forEach((report) => {
		// Capitalize the first letter
		const status = report.status.charAt(0).toUpperCase() + report.status.slice(1).toLowerCase();
		if (!Status.includes(status)) {
			Status.push(status);
		}
		if (!Dataset.includes(report.templateName)) {
			Dataset.push(report.templateName);
		}
		const frequency = [NOW, LATER, TODAY].includes(report.frequency) ? ONCE : report.frequency;
		if (!Frequency.includes(frequency)) {
			Frequency.push(frequency);
		}
	});
	Dataset.sort();
	Dataset.unshift(ALL);
	return {
		Status,
		Dataset,
		Frequency
	};
};

export const sortByDate = (a, b, direction, pKey) => {
	if (!a[pKey] || !b[pKey]) {
		return -1;
	}
	if (direction === 'asc') {
		return new Date(a[pKey]) - new Date(b[pKey]);
	} else {
		return new Date(b[pKey]) - new Date(a[pKey]);
	}
};

export const sortByName = (a, b, direction, pKey) => {
	if (!a[pKey] || !b[pKey]) {
		return -1;
	}
	if (direction === 'asc') {
		return a[pKey].toLowerCase() > b[pKey].toLowerCase() ? 1 : -1;
	} else {
		return a[pKey].toLowerCase() < b[pKey].toLowerCase() ? 1 : -1;
	}
};

export const hasOwn = (obj, key) => {
	for (const objKey of Object.keys(obj)) {
		if (objKey === key) {
			return true;
		}
	}

	return false;
};

/* This returns the key of object for which value matches*/
export const getKeyByValue = (object, value) => {
	return Object.keys(object).find((key) => object[key] === value);
};
